import { ColorIcon, colors, HStack } from "goi_common";

export const StarScore = ({ score }: { score?: number }) => {
  return (
    <HStack alignItems="center" gap={5}>
      <ColorIcon name="rating_star" color={colors.orange650} width="18px" height="18px" />
      <div className="body_14_m gray500">{score && score >= 0 ? score.toFixed(1) : "-"}</div>
    </HStack>
  );
};
